export default class ObjectUtil {
  static isEmpty(obj) {
    return obj == null || obj === undefined;
  }
}
